import React, { Component, Fragment } from 'react';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

const options = ({ t }) => [
  { value: 'all', title: t('All Invoices') },
  { value: 'unassigned', title: t('Unassigned Invoices') },
  { value: 'unassignedShipments', title: t('Unassigned Shipments') }
];

const styles = () => ({
  button: {
    position: 'absolute',
    top: 0,
    right: -48
  },
  menuItemRoot: {
    color: 'rgba(12,31,44,0.87)',
    fontFamily: 'Roboto',
    fontSize: '14px',
    letterSpacing: '0.15px',
    lineHeight: '20px',
    backgroundColor: '#FFF !important',
    height: '40px',
    padding: '0 9px',
    '&:hover': {
      backgroundColor: 'whitesmoke !important'
    }
  },
  menuItemSelected: {
    backgroundColor: '#ebebeb !important'
  }
});

export class GeneralFilter extends Component {
  state = {
    anchorEl: null
  };

  _handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  _handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { t, classes } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);

    return (
      <Fragment>
        <IconButton
          aria-label="More"
          aria-owns={open ? 'long-menu' : undefined}
          aria-haspopup="true"
          onClick={this._handleClick}
          className={classes.button}
        >
          <KeyboardArrowDownIcon />
        </IconButton>
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={this._handleClose}
        >
          {options({ t }).map(option => (
            <MenuItem
              key={option.value}
              selected={option.value === 'all'}
              onClick={this._handleClose}
              classes={{
                root: classes.menuItemRoot,
                selected: classes.menuItemSelected
              }}
            >
              {option.title}
            </MenuItem>
          ))}
        </Menu>
      </Fragment>
    );
  }
}

const translatedGeneralFilter = withNamespaces()(GeneralFilter);
export default withStyles(styles)(translatedGeneralFilter);
